import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class ProductListsService {
  fetchProductLists = (params) => {
    return fetch(config.config.endpointUrls.fetchProductLists(params), {
      method: 'GET'
    })
  }
  fetchProductList = (params) => {
    return fetch(config.config.endpointUrls.fetchProductList(params), {
      method: 'GET'
    })
  }
  createProductList = (fields) => {
    return fetch(config.config.endpointUrls.createProductList(), {
      method: 'POST',
      body: fields
    })
  }
  updateProductList = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateProductList({ id }), {
      method: 'PATCH',
      body: fields
    })
  }
  putProductList  = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateProductList({ id }), {
      method: 'PUT',
      body: fields
    })
  }
  deleteProductList  = ({ id }) => {
    return fetch(config.config.endpointUrls.updateProductList({ id }), {
      method: 'DELETE'
    })
  }
}

export default new ProductListsService()



// WEBPACK FOOTER //
// ../src/services/productListService/productListService.js